// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const dondozo: PokeData = {
  "id": 977,
  "name": "dondozo",
  "height": 120,
  "weight": 2200,
  "base_experience": 265,
  "types": [
    PokeType.WATER
  ],
  "api_moves": [
    "tackle",
    "body-slam",
    "double-edge",
    "supersonic",
    "water-gun",
    "rest",
    "flail",
    "sleep-talk",
    "rain-dance",
    "dive",
    "tickle",
    "aqua-tail",
    "heavy-slam",
    "soak",
    "noble-roar",
    "wave-crash",
    "order-up"
  ],
  "moves": [
    "tackle",
    "body-slam",
    "supersonic",
    "rain-dance",
    "aqua-tail",
    "life-dew",
    "brine",
    "water-spout",
    "bubble",
    "bubble-beam",
    "whirlpool",
    "aqua-jet",
    "aqua-cutter"
  ],
  "evolution_chain": {
    "id": 513,
    "item": null,
    "species": [
      {
        "name": "dondozo",
        "order": 931,
        "types": [
          PokeType.WATER
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      }
    ]
  },
  "stats": {
    "resistance": 188,
    "speed": 55,
    "ability_power": 157
  },
  "stat_changes": [],
  "catch_rate": 25,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
